/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ImageErrorIcon = createIcon("ImageErrorIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "76",
    height: "76",
    viewBox: "0 0 76 76",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    opacity: ".4",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M13 15v47a4 4 0 004 4h31l15-14.984V15a4 4 0 00-4-4H17a4 4 0 00-4 4Z",
    fill: "#3894FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".4",
    d: "M48 55v11l15-15H52a4 4 0 00-4 4Z",
    fill: "#1C69F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.916 25.819c.188.13.351.293.484.48l8.873 12.496a1.995 1.995 0 01-1.627 3.15H41.81l.04.055H25.994a1.995 1.995 0 01-1.645-3.123l5.828-8.502a1.995 1.995 0 013.264-.038l1.461 2.028 4.235-6.055a1.995 1.995 0 012.778-.491Zm-13.126-5.82a2.993 2.993 0 110 5.986 2.993 2.993 0 010-5.985Z",
    fill: "#3894FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 44a.5.5 0 100 1 .5.5 0 000-1Z",
    fill: "#AB0000",
    stroke: "#AB0000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 40V30",
    stroke: "#AB0000",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.707 39.708a2.416 2.416 0 010-3.415l12.586-12.585a2.41 2.41 0 013.414 0l12.586 12.585a2.416 2.416 0 010 3.415L39.707 52.293a2.415 2.415 0 01-3.414 0L23.707 39.708Z",
    stroke: "#AB0000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});